export enum DerivedItemRateTypeNames {
  REGULAR = 'regular',
  OVERTIME = 'overtime',
  DOUBLE = 'double',
  PM_RATE = 'pm_rate',
  ON_DEMAND_RATE = 'on_demand_rate'
}
